import styled from 'styled-components';
import Grid from '$components/layout/Grid';
import { DotLine } from '$components/basic/DotLine';
import { vars, fontWeight, media, pxToRem } from '$util/theme';

export const DotLineStyled = styled(DotLine)`
  &.top-dots,
  &.middle-dots,
  &.bottom-dots {
    margin-bottom: 5px;
    ${media.up('md')} {
      display: none;
    }
  }

  &.top-dots {
    max-width: 200px;
  }
`;

export default styled(Grid)`
  background: ${vars.quantumverse.reskinColors.brandDarkPurple};

  &.-light {
    background: ${vars.quantumverse.reskinColors.white};
    h3.title {
      color: ${vars.quantumverse.reskinColors.brandYellow};
    }
    h5.title {
      padding-top: 15px;
      font-size: ${pxToRem(16)};
      text-align: center;
      display: block;
      margin: auto;
      ${media.up('lg')} {
        width: 50%;
      }
    }
    .Tile .title {
      color: ${vars.quantumverse.reskinColors.neutral700};
    }
  }

  h3.title {
    text-align: center;
    width: 100%;
    color: ${vars.quantumverse.reskinColors.purple800};
    font-weight: normal;
    margin: 0;
    ${media.up('lg')} {
      font-size: ${pxToRem(32)};
    }
  }
  .Tile {
    text-align: center;
    border: none !important;
    padding: 20px 0 0 0;
    ${media.down('sm')} {
      padding-bottom: 0;
    }
    ${media.down('lg')} {
      padding-left: 0;
      padding-right: 0;
    }
    .title {
      color: ${vars.quantumverse.reskinColors.neutral600};
      font-weight: normal;
      margin-top: 16px;
      margin-bottom: 8px;
      font-size: ${pxToRem(20)};
      line-height: ${pxToRem(24)};
      ${media.down('md')} {
        font-size: ${pxToRem(16)};
        line-height: ${pxToRem(20)};
        font-weight: ${fontWeight.bold};
        margin: 12px auto 6px auto;
      }
    }
    .content {
      color: ${vars.quantumverse.reskinColors.neutral300};
      line-height: ${pxToRem(16)};
      font-size: ${pxToRem(13)};
      padding: 0 8px;
      margin: 0;
    }
    .img-svg {
      width: 56px;
      height: 64px;
    }
  }

  &.-blueIcons,
  &.-blueIconsV2 {
    margin-bottom: 0.5em !important;
  }

  &.-blueIcons,
  &.-blueIconsV2,
  &.-blueIconCarServiceMakeExperiment,
  &.-blueIconMotExperiment {
    h3.title {
      color: ${vars.quantumverse.reskinColors.neutral700};
      font-size: ${pxToRem(24)};
      font-weight: ${fontWeight.light};
      line-height: ${pxToRem(28)};
      ${media.up('md')} {
        font-size: ${pxToRem(32)};
        line-height: ${pxToRem(40)};
      }
    }
    .Tile {
      .title,
      .content {
        color: ${vars.quantumverse.reskinColors.neutral700};
      }
      .title {
        font-size: ${pxToRem(16)};
        font-weight: ${fontWeight.semiBold};
        max-width: unset !important;
        margin-bottom: 8px;
        ${media.up('md')} {
          font-size: ${pxToRem(23)};
          line-height: ${pxToRem(23)};
        }
      }
      .content,
      .btn-link,
      .btn-link > span {
        font-size: ${pxToRem(14)};
        line-height: ${pxToRem(20)};
        ${media.up('md')} {
          font-size: ${pxToRem(17)};
          line-height: ${pxToRem(24)};
        }
      }
      .btn-link,
      .btn-link > span {
        color: ${vars.quantumverse.reskinColors.purple500} !important;
        text-decoration-color: ${vars.quantumverse.reskinColors.purple500};
      }
      ${media.down('md')} {
        display: flex;
        align-items: flex-start;
        > img {
          width: 10vw;
          max-width: 50px;
          ${media.down('sm')} {
            margin-top: 10px;
          }
        }
        > div {
          display: flex;
          flex-direction: column;
          text-align: left;
          margin-left: 0;
          margin-right: 18px;
          width: 85%;
          ${media.down('sm')} {
            width: 100%;
          }
          > .title {
            margin: 0 auto 8px 8px;
          }
        }
      }
    }
  }

  &.-blueIcons,
  &.-blueIconCarServiceMakeExperiment,
  &.-blueIconMotExperiment {
    background: ${vars.quantumverse.reskinColors.neutral100};
  }

  &.-blueIconsV2 {
    padding: 0 0 ${pxToRem(60)} 0 !important;
    background: ${vars.quantumverse.reskinColors.white};
    .title {
      text-align: left;
    }
    .Tile {
      text-align: left;
      display: flex;
      align-items: flex-start;
      max-width: ${pxToRem(720)};
      > img {
        width: 10vw;
        max-width: 50px;
        ${media.down('sm')} {
          margin-top: 10px;
        }
      }
      > div {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-left: 10px;
        width: 85%;
        ${media.down('sm')} {
          width: 100%;
        }
        > .title {
          margin: 0 auto 8px 8px;
        }
      }
    }
    ${media.up('lg')} {
      padding-top: 72px;
      padding-bottom: 72px;
      padding-left: 48px;
      padding-right: 48px;
    }
  }

  ${media.between('md', 'lg')} {
    .Col:nth-child(1) p.title {
      max-width: ${pxToRem(80)};
    }

    .Col:nth-child(2) p.title {
      max-width: ${pxToRem(120)};
    }

    .Col:nth-child(3) p.title {
      max-width: ${pxToRem(120)};
    }

    .Col:nth-child(4) p.title {
      max-width: ${pxToRem(120)};
    }
  }
`;
